import React,{useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/common/header';
import Footer from '../../components/common/footer';
import pageerror from "../../assets/images/404-error.jpg";


const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const version = process.env.REACT_APP_VERSION;

  useEffect(() => {
    fetchSeoMetaDetails()
  },[]);

const fetchSeoMetaDetails = async () => {
    try {
        const code = 'login_page'
        const response = await fetch(`${backendUrl}${version}seo-meta-details/${code}`,
          {  method: 'GET',
            headers:{
              // Accept:'aplication/json',
              "Content-Type": "application/json",
      
            },
            credentials: "include",
            mode:"cors"                 
          }
        );
        if (!response.ok) throw new Error('Failed to fetch categories');
        const data = await response.json();
        await changeTitleAndMetaTags(data.result.page_title, {description:data.result.meta_description,keywords:data.result.meta_tag});
    } catch (error) {
        //console.error('Error fetching categories:', error);
    }
  };
  
  const changeTitleAndMetaTags = async (
    title: string,
    metaTags: { description?: string; keywords?: string; [key: string]: string | undefined }
  ) => {
    try {
        // Update the document title
        if (title) {
            document.title = title;
        } else {
            document.title = "Sell Used Appliances Online in India - Instant Cash & Free Pickup | Selsmart";
        }
  
        // Update or create meta tags
        Object.keys(metaTags).forEach((metaName) => {
            const metaTag = document.querySelector(`meta[name="${metaName}"]`);
            if (metaTag) {
                // Update existing meta tag
                metaTag.setAttribute('content', metaTags[metaName] || `Default ${metaName} for Selsmart`);
            } else {
                // Create new meta tag if it doesn't exist
                const newMetaTag = document.createElement('meta');
                newMetaTag.name = metaName;
                newMetaTag.content = metaTags[metaName] || `Default ${metaName} for Selsmart`;
                document.head.appendChild(newMetaTag);
            }
        });
  
        // Cleanup function to reset the title and meta tags when unmounting
        return () => {
            document.title = "Sell Used Appliances Online in India - Instant Cash & Free Pickup | Selsmart";
            Object.keys(metaTags).forEach((metaName) => {
                const metaTag = document.querySelector(`meta[name="${metaName}"]`);
                if (metaTag) {
                    metaTag.setAttribute('content', `Default ${metaName} for Selsmart`);
                }
            });
        };
    } catch (error) {
        //console.error("Error updating title and meta tags:", error);
    }
  };

  return (
    <div>
      <Header
        // onSelectCity={handleSelectCityClick}
        // cityName={cityName || 'Select City'}
        />
        <div className='not_found' style={{ textAlign: 'center', padding: '50px' }}>
        {/* <img src={pageerror} alt="" /> */}

      <h1>404 - Page Not Found</h1>

     
      <p>Sorry, the page you're looking for doesn't exist.</p>
      <button onClick={() => navigate('/')}>Go to Home</button>
    </div>
    <Footer />
    </div>
    
  );
};

export default NotFoundPage;
